import { render } from "./SideBarAdmin.vue?vue&type=template&id=b8fb5204&scoped=true"
import script from "./SideBarAdmin.vue?vue&type=script&lang=js"
export * from "./SideBarAdmin.vue?vue&type=script&lang=js"

import "./SideBarAdmin.vue?vue&type=style&index=0&id=b8fb5204&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b8fb5204"

export default script